module.exports = {"640423100":"城关镇","640423101":"沙塘镇","640423102":"联财镇","640423200":"陈靳乡","640423201":"好水乡","640423202":"观庄乡","640423203":"杨河乡","640423204":"神林乡","640423205":"张程乡","640423206":"凤岭乡","640423207":"山河乡","640423208":"温堡乡","640423209":"奠安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640423.json
// module id = 2828
// module chunks = 0